import type { FaireProductEntity } from "../../entity_types/product";

export const p_tp967eew7r: FaireProductEntity = {
  token: "p_tp967eew7r",
  type: "product",
  name: "Refillable Deodorant Tube-Designed for Compostable Refills",
  brandToken: "b_7t7wu79e8q",
  brandName: "Terra and Self",
  imageUrl:
    "https://cdn.faire.com/fastly/05d6f3639f8d11e6cdf63124e68d85411be138a431041840036aa0cffa3f2eaa.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/001b3090609530661811de0c962d8d6d8a89a7d603ddee4fd77d5eeb5d280d3a.png",
    "https://cdn.faire.com/fastly/1324d8978b7e43796e5d993df7e562f9538ce5ea5d0ed41dfd4224a68dda98e0.png",
    "https://cdn.faire.com/fastly/f1ee37d391be650150a30dbf1b8934628494c45b6751e1a5cb91b8b361e769fd.png",
    "https://cdn.faire.com/fastly/cfa27567765f0ecc7eae80192bae9d6747612a6e4f8674cea00022c3566b0aed.png",
  ],
  priceDollars: 7.62,
  description:
    "Our refillable deodorant tube is designed to stick with your customers for the long haul. Made from durable calcium carbonate, this outer tube is built to be reused again and again, while our compostable refills make restocking simple and intentional.\n\nCustomers purchase the tube once, then come back for refills every 4 to 5 weeks, creating built in repeat purchases for your store. The refill system keeps things easy, familiar, and low commitment for first time buyers while encouraging long term loyalty.\n\nSleek, sturdy, and thoughtfully designed, this tube pairs seamlessly with all Terra & Self deodorant refills and fits perfectly into a refill forward routine customers actually enjoy using.\n\nFeatures:\n-Durable refillable tube made from calcium carbonate\n-Designed to be reused again and again\n-Compostable refill system encourages repeat purchases\n-Easy, mess free refill process\n-Helps build customer loyalty and predictable restocks",
  tags: [],
  msrpDollars: 15.24,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-27T00:07:47.196Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
